import { useMemo, useState } from 'react';
import { ErrorState, Loading } from '../../components/States';
import { useAdminStudents } from '../../hooks/api-hooks';
import { formatDateTime, formatPrice } from '../../lib/format';

export function AdminStudentsPage() {
  const students = useAdminStudents();
  const [search, setSearch] = useState('');
  const filtered = useMemo(() => {
    const keyword = search.trim().toLocaleLowerCase('vi');
    if (!keyword) return students.data ?? [];
    return (students.data ?? []).filter((student) =>
      [student.fullName, student.email].some((value) => value?.toLocaleLowerCase('vi').includes(keyword)),
    );
  }, [search, students.data]);

  return (
    <section className="admin-page">
      <header className="admin-page-header">
        <div><h1>Học viên</h1><p>Danh sách tài khoản, quyền truy cập và lịch sử mua hàng.</p></div>
        <label className="admin-search"><span className="sr-only">Tìm học viên</span><input type="search" placeholder="Tìm tên hoặc email…" value={search} onChange={(event) => setSearch(event.target.value)} /></label>
      </header>
      {students.isPending && <Loading label="Đang tải học viên…" />}
      {students.error && <ErrorState error={students.error} />}
      {students.data && (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead><tr><th>Học viên</th><th>Đã sở hữu</th><th>Đơn đã trả</th><th>Tổng chi</th><th>Ngày tham gia</th></tr></thead>
            <tbody>
              {filtered.map((student) => <tr key={student.id}>
                <td><strong>{student.fullName || 'Chưa đặt tên'}</strong><small>{student.email}</small></td>
                <td>{student.accessCount} sản phẩm</td>
                <td>{student.paidOrderCount}</td>
                <td>{formatPrice(Number(student.totalSpent))}</td>
                <td>{formatDateTime(student.createdAt)}</td>
              </tr>)}
              {!filtered.length && <tr><td colSpan={5} className="admin-empty">Không tìm thấy học viên.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
